import { useCallback } from "react";

export default function ProductSubmitActions({
  parseMultilineUrls,
  newProduct,
  setAdminError,
  editingProductId,
  apiBaseUrl,
  adminFetch,
  readApiJson,
  fetchAdminData,
  fetchPositionWorkspaceData,
  resetProductEditorState,
  setAdminTab
}) {
  const parseParameterLines = useCallback((text) => {
    return String(text || "")
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => {
        const [rawKey, ...rest] = line.split(":");
        const key = (rawKey || "").trim();
        const value = rest.join(":").trim();
        if (!key || !value) {
          return null;
        }

        return { key, value };
      })
      .filter(Boolean);
  }, []);

  const submitProductEditor = useCallback(async (event) => {
    event.preventDefault();

    const mainImages = parseMultilineUrls(newProduct.mainImagesText);
    if (mainImages.length !== 6) {
      setAdminError("Please provide exactly 6 main image URLs.");
      return;
    }

    const detailImages = parseMultilineUrls(newProduct.detailImagesText);
    const parameters = parseParameterLines(newProduct.parametersText);

    try {
      const requestUrl = editingProductId ? `${apiBaseUrl}/admin/products/${editingProductId}` : `${apiBaseUrl}/admin/products`;
      const requestMethod = editingProductId ? "PATCH" : "POST";
      const response = await adminFetch(requestUrl, {
        method: requestMethod,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          sku: newProduct.sku,
          model: newProduct.model,
          category: newProduct.category,
          title: newProduct.title,
          subtitle: String(newProduct.subtitle || "").trim(),
          brandName: String(newProduct.brandName || "").trim(),
          description: newProduct.description,
          priceUSD: Number(newProduct.priceUSD),
          priceUnitCode: String(newProduct.priceUnitCode || "piece").trim() || "piece",
          isBestSelling: newProduct.isBestSelling === true,
          salesCount: Math.max(0, Math.floor(Number(newProduct.salesCount || 0) || 0)),
          imageUrl: newProduct.imageUrl,
          mainImages,
          detailVideoUrl: newProduct.detailVideoUrl,
          detailContent: String(newProduct.detailContentText || "").trim(),
          parameters,
          detailImages
        })
      });

      const data = await readApiJson(response);
      if (!response.ok) {
        throw new Error(data.message || (editingProductId ? "Update product failed" : "Create product failed"));
      }

      await Promise.all([fetchAdminData(), fetchPositionWorkspaceData()]);
      resetProductEditorState();
      setAdminTab("products");
    } catch (err) {
      if (err.message !== "Session expired") {
        setAdminError(err.message);
      }
    }
  }, [
    adminFetch,
    apiBaseUrl,
    editingProductId,
    fetchAdminData,
    fetchPositionWorkspaceData,
    newProduct,
    parseMultilineUrls,
    parseParameterLines,
    readApiJson,
    resetProductEditorState,
    setAdminError,
    setAdminTab
  ]);

  return {
    submitProductEditor
  };
}
